export const General = {
  Env: {
    style: {
      size: {
        navigation: {
          height: 86,
        },
        drawer: {
          width: 250,
          mini: {
            width: 60,
          }
        },
        fileImage: {
          width: 100,
        }
      },
      palette: {
        primary: {
          main: "#2d3139",
          light: "#707b8f",
          dark: "#17191d",
        },
        secondary: {
          main: "#faf7f1",
          light: "#ffffff",
          dark: "#f8f4ec",
        }
      },
      fontFamily: {
        primary: `"EB Garamond", serif`,
      },
    },
    companyName: "momodeblog",
  },
  Nation: {
    vi: {
      code: "vi",
      name: "vi",
      label: "Vietnam",
      localeLabel: "Vietnamese",
      localeShortLabel: "VI",
      flagClassName: "fi fi-vn fis",
      phonePrefix: "+84",
      holidayRegionCode: "en.vietnamese",
    },
    ja: {
      code: "ja",
      name: "ja",
      label: "日本",
      localeLabel: "日本語",
      localeShortLabel: "JA",
      flagClassName: "fi fi-jp fis",
      phonePrefix: "+81",
      holidayRegionCode: "en.japanese",
    },
    en: {
      code: "en",
      name: "en",
      label: "US",
      localeLabel: "English",
      localeShortLabel: "EN",
      flagClassName: "fi fi-us fis",
      phonePrefix: "+1",
      holidayRegionCode: "en.usa",
    },
  },
  Crud: {
    Create: {
      code: "create",
      name: "create",
      label: "Create",
    },
    Read: {
      code: "read",
      name: "read",
      label: "Read",
    },
    Update: {
      code: "update",
      name: "update",
      label: "Update",
    },
    Delete: {
      code: "delete",
      name: "delete",
      label: "Delete",
    },
  },
};
export const Theme = {
  Default: {
    palette: {
      primary: {
        main: General.Env.style.palette.primary.main,
        light: General.Env.style.palette.primary.light,
        dark: General.Env.style.palette.primary.dark,
        contrastText: General.Env.style.palette.secondary.light,
      },
      secondary: {
        main: General.Env.style.palette.secondary.main,
        light: General.Env.style.palette.secondary.light,
        dark: General.Env.style.palette.secondary.dark,
        contrastText: General.Env.style.palette.primary.light,
      },
    },
    components: {
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: General.Env.style.palette.secondary.main,
            color: General.Env.style.palette.primary.main,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            "&:hover": {
              color: General.Env.style.palette.primary.dark,
              background: General.Env.style.palette.secondary.dark,
            },
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            "&:hover": {
              background: General.Env.style.palette.secondary.main,
              color: General.Env.style.palette.primary.main,
            },
          }
        }
      },
      MuiLink: {
        styleOverrides: {
          root: {
            cursor: "pointer",
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: General.Env.style.palette.secondary.main,
            color: General.Env.style.palette.primary.main,
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.main,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.dark,
            minHeight: 40,
          },
          indicator: {
            background: General.Env.style.palette.primary.main,
            height: 3,
          },
        },
      },
      MuiAvatar: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.primary.light,
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.main,
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          paper: {
            background: General.Env.style.palette.secondary.main,
          },
          option: {
            display: "flex",
            "& .option-label": {
              flexGrow: 1,
            },
            "& .option-check-icon": {
              color: General.Env.style.palette.primary.main,
            },
          },
          tag: {
            borderRadius: 3,
            height: "auto",
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.dark,
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.main,
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.dark,
            color: General.Env.style.palette.primary.dark,
          },
        },
      },
      MuiPickersLayout: {
        styleOverrides: {
          root: {
            background: General.Env.style.palette.secondary.main,
          },
        },
      },
    },
    typography: {
      fontFamily: General.Env.style.fontFamily.primary,
    },
  }
};
export const Config = {
  WeekBeginning: {
    Monday: {
      code: "monday",
      name: "monday",
      label: "Monday",
      moment: 1,
    },
    Sunday: {
      code: "sunday",
      name: "sunday",
      label: "Sunday",
      moment: 0,
    },
  },
  TimeDisplay: {
    _12h: {
      code: "_12h",
      name: "_12h",
      label: "12h",
    },
    _24h: {
      code: "_24h",
      name: "_24h",
      label: "24h",
    },
  },
  WeekOfMonth: {
    _0: { code: 0, name: 'week_of_month_0', label: 'week_of_month_0' },
    _1: { code: 1, name: 'week_of_month_1', label: 'week_of_month_1' },
    _2: { code: 2, name: 'week_of_month_2', label: 'week_of_month_2' },
    _3: { code: 3, name: 'week_of_month_3', label: 'week_of_month_3' },
    _4: { code: 4, name: 'week_of_month_4', label: 'week_of_month_4' },
  },
  DayOfMonth: {
    _0: { code: 0, name: 'day_of_month_0', label: 'day_of_month_0' },
    _1: { code: 1, name: 'day_of_month_1', label: 'day_of_month_1' },
    _2: { code: 2, name: 'day_of_month_2', label: 'day_of_month_2' },
    _3: { code: 3, name: 'day_of_month_3', label: 'day_of_month_3' },
    _4: { code: 4, name: 'day_of_month_4', label: 'day_of_month_4' },
    _5: { code: 5, name: 'day_of_month_5', label: 'day_of_month_5' },
    _6: { code: 6, name: 'day_of_month_6', label: 'day_of_month_6' },
    _7: { code: 7, name: 'day_of_month_7', label: 'day_of_month_7' },
    _8: { code: 8, name: 'day_of_month_8', label: 'day_of_month_8' },
    _9: { code: 9, name: 'day_of_month_9', label: 'day_of_month_9' },
    _10: { code: 10, name: 'day_of_month_10', label: 'day_of_month_10' },
    _11: { code: 11, name: 'day_of_month_11', label: 'day_of_month_11' },
    _12: { code: 12, name: 'day_of_month_12', label: 'day_of_month_12' },
    _13: { code: 13, name: 'day_of_month_13', label: 'day_of_month_13' },
    _14: { code: 14, name: 'day_of_month_14', label: 'day_of_month_14' },
    _15: { code: 15, name: 'day_of_month_15', label: 'day_of_month_15' },
    _16: { code: 16, name: 'day_of_month_16', label: 'day_of_month_16' },
    _17: { code: 17, name: 'day_of_month_17', label: 'day_of_month_17' },
    _18: { code: 18, name: 'day_of_month_18', label: 'day_of_month_18' },
    _19: { code: 19, name: 'day_of_month_19', label: 'day_of_month_19' },
    _20: { code: 20, name: 'day_of_month_20', label: 'day_of_month_20' },
    _21: { code: 21, name: 'day_of_month_21', label: 'day_of_month_21' },
    _22: { code: 22, name: 'day_of_month_22', label: 'day_of_month_22' },
    _23: { code: 23, name: 'day_of_month_23', label: 'day_of_month_23' },
    _24: { code: 24, name: 'day_of_month_24', label: 'day_of_month_24' },
    _25: { code: 25, name: 'day_of_month_25', label: 'day_of_month_25' },
    _26: { code: 26, name: 'day_of_month_26', label: 'day_of_month_26' },
    _27: { code: 27, name: 'day_of_month_27', label: 'day_of_month_27' },
    _29: { code: 29, name: 'day_of_month_29', label: 'day_of_month_29' },
    _30: { code: 30, name: 'day_of_month_30', label: 'day_of_month_30' },
  },
  MonthOfYear: {
    _0: { code: 0, name: 'monthOfYear0', label: 'monthOfYear0', season: 0, seasonLabel: 'seasonOfYear0' },
    _1: { code: 1, name: 'monthOfYear1', label: 'monthOfYear1', season: 0, seasonLabel: 'seasonOfYear0' },
    _2: { code: 2, name: 'monthOfYear2', label: 'monthOfYear2', season: 0, seasonLabel: 'seasonOfYear0' },
    _3: { code: 3, name: 'monthOfYear3', label: 'monthOfYear3', season: 1, seasonLabel: 'seasonOfYear1' },
    _4: { code: 4, name: 'monthOfYear4', label: 'monthOfYear4', season: 1, seasonLabel: 'seasonOfYear1' },
    _5: { code: 5, name: 'monthOfYear5', label: 'monthOfYear5', season: 1, seasonLabel: 'seasonOfYear1' },
    _6: { code: 6, name: 'monthOfYear6', label: 'monthOfYear6', season: 2, seasonLabel: 'seasonOfYear2' },
    _7: { code: 7, name: 'monthOfYear7', label: 'monthOfYear7', season: 2, seasonLabel: 'seasonOfYear2' },
    _8: { code: 8, name: 'monthOfYear8', label: 'monthOfYear8', season: 2, seasonLabel: 'seasonOfYear2' },
    _9: { code: 9, name: 'monthOfYear9', label: 'monthOfYear9', season: 3, seasonLabel: 'seasonOfYear3' },
    _10: { code: 10, name: 'monthOfYear10', label: 'monthOfYear10', season: 3, seasonLabel: 'seasonOfYear3' },
    _11: { code: 11, name: 'monthOfYear11', label: 'monthOfYear11', season: 3, seasonLabel: 'seasonOfYear3' },
  }
};

// data
export const User = {
  Role: {
    Guest: {
      code: "guest",
      name: "guest",
      label: "guest",
      roles: ["guest"],
      allowedKeywords: ['sort', 'limit', 'skip', 'sortBy', 'sortOrder', 'nextToken'],
      isMaintainer: false,
      apiPath: "",
    },
    User: {
      code: "user",
      name: "user",
      label: "User",
      roles: ["user", "guest"],
      allowedKeywords: ['sort', 'limit', 'skip', 'sortBy', 'sortOrder', 'nextToken'],
      isMaintainer: false,
      apiPath: "user",
    },
    Staff: {
      code: "staff",
      name: "staff",
      label: "Staff",
      roles: ["staff", "user"],
      allowedKeywords: [],
      isMaintainer: false,
      apiPath: "staff",
    },
    Moderator: {
      code: "moderator",
      name: "moderator",
      label: "Moderator",
      roles: ["moderator", "staff", "user"],
      allowedKeywords: [],
      isMaintainer: true,
      apiPath: "moderator",
    },
    Admin: {
      code: "admin",
      name: "admin",
      label: "Admin",
      roles: ["admin", "moderator", "staff", "user"],
      allowedKeywords: [],
      isMaintainer: true,
      apiPath: "admin",
    },
    Root: {
      code: "root",
      name: "root",
      label: "Root",
      roles: ["root", "admin", "moderator", "staff", "user"],
      allowedKeywords: [],
      isMaintainer: true,
      apiPath: "admin",
    },
  },
  ContractType: {
    FullTime: {
      code: "fullTime",
      name: "fullTime",
      label: "Full Time",
    },
    PartTime: {
      code: "partTime",
      name: "partTime",
      label: "Part Time",
    },
  },
};
export const AccessHistory = {
  Type: {
    SignUp: {
      code: "signUp",
      name: "signUp",
      label: "Sign Up",
    },
    SignIn: {
      code: "signIn",
      name: "signIn",
      label: "Sign In",
    },
    SignOut: {
      code: "signOut",
      name: "signOut",
      label: "Sign Out",
    },
  },
};
export const Order = {
  Type: {
    B2C: {
      code: "b2c",
      name: "b2c",
      label: "B2C",
    },
    B2B: {
      code: "b2b",
      name: "b2b",
      label: "B2B",
    },
  },
  Status: {
    InProcess: {
      code: "inProcess",
      name: "inProcess",
      label: "InProcess",
    },
    Cancelled: {
      code: "cancelled",
      name: "cancelled",
      label: "Cancelled",
    },
    Done: {
      code: "done",
      name: "done",
      label: "Done",
    },
  },
};
export const File = {
  Type: {
    UserAvatar: {
      code: "userAvatar",
      name: "userAvatar",
      label: "constant.file.type.userAvatar",
      path: "assets/userAvatar",
      accept: "image/*",
    },
    ArticleLibrary: {
      code: "articleLibrary",
      name: "articleLibrary",
      label: "constant.file.type.articleLibrary",
      path: "assets/articleLibrary",
      accept: "image/*,audio/*,video/*",
    },
    IconImage: {
      code: "iconImage",
      name: "iconImage",
      label: "constant.file.type.iconImage",
      path: "assets/iconImage",
      accept: "image/*",
    },
    WeddingLibrary: {
      code: "weddingLibrary",
      name: "weddingLibrary",
      label: "constant.file.type.weddingLibrary",
      path: "assets/weddingLibrary",
      accept: "image/*,audio/*,video/*",
    },
    ProductImage: {
      code: "productImage",
      name: "productImage",
      label: "constant.file.type.productImage",
      path: "assets/productImage",
      accept: "image/*",
    },
    UserIdentity: {
      code: "userIdentity",
      name: "userIdentity",
      label: "constant.file.type.userIdentity",
      path: "assets/userIdentity",
      accept: "image/*",
    },
  },
  FileType: {
    Image: {
      code: "image",
      name: "image",
      label: "Image",
      extensions: [
        'jpg', 'jpeg', 'jpe', 'jif', 'jfif', 'jfi', 'png', 'gif', 'webp',
        'tiff', 'tif', 'psd', 'raw', 'arw', 'cr2', ' nrw', 'k25', 'bmp',
        'dib', 'heif', 'heic', 'ind', 'indd', 'indt', 'jp2', 'j2k', 'jpf',
        'jpx', 'jpm', 'mj2', 'svg', 'svgz', 'eps'
      ],
      contentType: 'image/*',
    },
    Audio: {
      code: "audio",
      name: "audio",
      label: "Audio",
      extensions: [
        'm4a', 'flac', 'mp3', 'wav', 'wma', 'aac'
      ],
      contentType: 'audio/*',
    },
    Video: {
      code: "video",
      name: "video",
      label: "Video",
      extensions: [
        'mp4', 'wov', 'wmv', 'avi', 'avchd', ' flv', 'f4v', 'swf', 'mkv', ' webm', 'mpeg',
      ],
      contentType: 'video/*',
    },
    Other: {
      code: "other",
      name: "other",
      label: "other",
      extensions: [],
      contentType: '/*',
    },
  }
};
export const WebSocket = {
  Action: {
    ServerSystemMessage: {
      code: "server_system_message",
      name: "server_system_message",
      label: "Server System Message",
    },
  },
};
export const Place = {
  Type: {
    FishingSpot: {
      code: "fishing_spot",
      name: "fishing_spot",
      label: "fishing_spot",
      markerColor: "#e6005c",
      markerIcon: "魚",
    },
    FishingService: {
      code: "fishing_service",
      name: "fishing_service",
      label: "fishing_service",
      markerColor: "#339933",
      markerIcon: "サ",
    },
    FishingTackleStore: {
      code: "fishing_tackle_store",
      name: "fishing_tackle_store",
      label: "fishing_tackle_store",
      markerColor: "#0066ff",
      markerIcon: "売",
    },
  },
  Status: {
    Private: {
      code: "private",
      name: "private",
      label: "private",
    },
    PublicRequest: {
      code: "public_request",
      name: "public_request",
      label: "public_request",
    },
    Public: {
      code: "public",
      name: "public",
      label: "public",
    },
    OnHold: {
      code: "on_hold",
      name: "on_hold",
      label: "on_hold",
    },
  }
};
export const Article = {
  Status: {
    Draft: {
      code: "draft",
      name: "draft",
      label: "constant.article.status.draft",
    },
    Public: {
      code: "public",
      name: "public",
      label: "constant.article.status.public",
    },
  },
  AutoSaveInterval: 10000, // 10 seconds
};

export const WeddingInvitation = {
  Type: {
    Bride: {
      code: "bride",
      name: "bride",
      label: "constant.weddingInvitation.type.bride",
    },
    Groom: {
      code: "groom",
      name: "groom",
      label: "constant.weddingInvitation.type.groom",
    },
    Friends: {
      code: "friends",
      name: "friends",
      label: "constant.weddingInvitation.type.friends",
    },
  },
  AttendanceStatus: {
    Attending: {
      code: "attending",
      name: "attending",
      label: "constant.weddingInvitation.attendanceStatus.attending",
    },
    NotAttending: {
      code: "notAttending",
      name: "notAttending",
      label: "constant.weddingInvitation.attendanceStatus.notAttending",
    },
    NoResponse: {
      code: "noResponse",
      name: "noResponse",
      label: "constant.weddingInvitation.attendanceStatus.noResponse",
    },
  },
};

//  components
export const DynamicDialog = {
  Variant: {
    Create: {
      code: "create",
      name: "create",
      label: "create",
    },
    Update: {
      code: "update",
      name: "update",
      label: "Update",
    },
    Show: {
      code: "show",
      name: "show",
      label: "show",
    },
    Confirm: {
      code: "confirm",
      name: "confirm",
      label: "confirm",
    },
    Info: {
      code: "info",
      name: "info",
      label: "info",
    },
    Panel: {
      code: "panel",
      name: "panel",
      label: "panel",
    },
    UpdatePanel: {
      code: "updatePanel",
      name: "updatePanel",
      label: "updatePanel",
    }
  },
}
export const AudioRecorder = {
  State: {
    Initialize: {
      code: "initialize",
      name: "initialize",
      label: "Initialize",
    },
    Recording: {
      code: "recording",
      name: "recording",
      label: "Recording",
    },
    Pausing: {
      code: "pausing",
      name: "pausing",
      label: "Pausing",
    },
    Stopped: {
      code: "stopped",
      name: "stopped",
      label: "Stopped",
    },
  },
};
export const Camera = {
  State: {
    Initialize: {
      code: "initialize",
      name: "initialize",
      label: "Initialize",
    },
    Recording: {
      code: "recording",
      name: "recording",
      label: "Recording",
    },
    Stopped: {
      code: "stopped",
      name: "stopped",
      label: "Stopped",
    },
  },
  FacingMode: {
    User: {
      code: "user",
      name: "user",
      label: "User",
    },
    Environment: {
      code: "environment",
      name: "environment",
      label: "Environment",
    },
  }
};
export const ColorPickerAdapter = {
  Color: {
    Color0: { code: "#3dc2c8", name: "blue", label: "#3dc2c8", className: "bg-3dc2c8" },
    Color1: { code: "#2ecc87", name: "green", label: "#2ecc87", className: "bg-2ecc87" },
    Color2: { code: "#e73b3b", name: "red", label: "#e73b3b", className: "bg-e73b3b" },
    Color3: { code: "#f35f8c", name: "pink", label: "#f35f8c", className: "bg-f35f8c" },
    Color4: { code: "#fdc02d", name: "yellow", label: "#fdc02d", className: "bg-fdc02d" },
    Color5: { code: "#b38bdc", name: "purple", label: "#b38bdc", className: "bg-b38bdc" },
  },
};

export const RichTextareaAdapter = {
  Color: {
    Color0: { code: "#3dc2c8", name: "blue", label: "#3dc2c8" },
    Color1: { code: "#2ecc87", name: "green", label: "#2ecc87" },
    Color2: { code: "#e73b3b", name: "red", label: "#e73b3b" },
    Color3: { code: "#f35f8c", name: "pink", label: "#f35f8c" },
    Color4: { code: "#fdc02d", name: "yellow", label: "#fdc02d" },
    Color5: { code: "#b38bdc", name: "purple", label: "#b38bdc" },
  },
  Background: {
    Background0: { code: "#d6f4f5", name: "blue-bg", label: "#d6f4f5" },
    Background1: { code: "#d4f7e5", name: "green-bg", label: "#d4f7e5" },
    Background2: { code: "#fcdada", name: "red-bg", label: "#fcdada" },
    Background3: { code: "#ffe0eb", name: "pink-bg", label: "#ffe0eb" },
    Background4: { code: "#fff4d1", name: "yellow-bg", label: "#fff4d1" },
    Background5: { code: "#f1e6fc", name: "purple-bg", label: "#f1e6fc" },
  }
};
export const GoogleMap = {
  MarkerType: {
    Point: {
      code: "point",
      name: "project",
      label: "Point",
      icon: "room",
    },
    Polygon: {
      code: "polygon",
      name: "area",
      label: "Polygon",
      icon: "format_shapes",
    },
    None: {
      code: "none",
      name: "none",
      label: "None",
      icon: "radar",
    },
  },
  MapType: {
    Roadmap: {
      code: "roadmap",
      name: "roadmap",
      label: "Roadmap",
    },
    Satellite: {
      code: "satellite",
      name: "satellite",
      label: "Satellite",
    },
    Hybrid: {
      code: "hybrid",
      name: "hybrid",
      label: "Hybrid",
    },
  }
};
export const Avatar = {
  Status: {
    Online: {
      code: "online",
      name: "online",
      label: "Online",
      className: "online",
    },
    Offline: {
      code: "offline",
      name: "offline",
      label: "Offline",
      className: "offline",
    },
  },
};
export const Navigation = {
  NativeMenu: {
    Notification: {
      code: "notification",
      name: "notification",
      label: "Notification",
    },
  },
};
export const SideBar = {
  Anchor: {
    Left: {
      code: "left",
      name: "left",
      label: "left",
    },
    Right: {
      code: "right",
      name: "right",
      label: "right",
    },
  },
  Variant: {
    Full: {
      code: "full",
      name: "full",
      label: "full",
    },
    Mini: {
      code: "mini",
      name: "mini",
      label: "mini",
    },
    Hidden: {
      code: "hidden",
      name: "hidden",
      label: "hidden",
    },
  }
};